import * as React from "react";
import AppIcon from "../components/AppIcon";
import { IDetectedBarcode, Scanner as QR } from "@yudiel/react-qr-scanner";
import { Exhibitor, GetExhibitors } from "./TreasureHunt";
import { useUser } from "../utils/AccountStore";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Scanner = () => {
    const [exhibitors, setExhibitors] = React.useState([] as Exhibitor[]);
    const [isScanning, setIsScanning] = React.useState(true);
    const [lastScan, setLastScan] = React.useState<string>("");
    const navigate = useNavigate();

    const { user } = useUser();

    React.useEffect(() => {
        GetExhibitors().then((res) => {
            setExhibitors(res.data);
        });
        window.scrollTo(0, 0);
    }, []);

    const handleScan = (barcodes: IDetectedBarcode[]) => {
        let text = barcodes[0]?.rawValue;
        if (text && text.includes("/exhibitors/")) {
            let id = text.split("/exhibitors/")[1];
            if (exhibitors.some((exhibitor) => exhibitor.id === id)) {
                setLastScan(text);
                setIsScanning(false);
                
                axios.post(`${Server}/api/attendees/scan`, { type: "exhibitor", id, userID: user.id }).then(() => {
                    // Add small delay for better UX
                    setTimeout(() => {
                        navigate("/exhibitorDetails/" + id);
                    }, 1000);
                });
            }
        }
    };

    const resetScanner = () => {
        setIsScanning(true);
        setLastScan("");
    };

    return (
        <div 
            className="min-h-screen bg-cover bg-center bg-no-repeat bg-fixed"
            style={{
                backgroundImage: "url(/images/collectivebg-2.jpg)",
                overflow: "hidden",
                height: "100vh"
            }}
        >
            <div className="min-h-screen backdrop-blur-sm" style={{ backgroundColor: "rgba(241, 245, 248, 0.9)" }}>
                {/* Header Section */}
                <div className="pt-8 pb-6">
                    <div className="max-w-4xl mx-auto px-8">
                        <div className="flex items-center justify-between mb-6">
                            <button
                                onClick={() => navigate('/home')}
                                className="flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1"
                                style={{ backgroundColor: "rgba(121, 153, 186, 0.9)" }}
                            >
                                <span className="text-white text-xl"><AppIcon kind="home" /></span>
                            </button>
                            
                            <div className="text-center w-full">
                                <h1 className="text-2xl font-bold mb-2" style={{ color: "#013A51" }}>
                                    QR Code Scanner
                                </h1>
                                <div className="w-24 h-1 mx-auto rounded-full" style={{ backgroundColor: '#DB1C7D' }}></div>
                            </div>
                            
                            <div className="w-24"></div> {/* Spacer for centering */}
                        </div>
                    </div>
                </div>

                {/* Content Section */}
                <div className="px-8 pb-8">
                    <div className="max-w-4xl mx-auto">
                        {/* Instructions Card */}
                        {/* <div className="bg-white bg-opacity-60 backdrop-blur-sm rounded-2xl p-6 shadow-lg mb-8" style={{ borderLeft: `4px solid #DB1C7D` }}>
                            <div className="text-center">
                                <div className="mb-4">
                                    <span className="text-4xl"><AppIcon kind="qr" /></span>
                                </div>
                                <h2 className="text-2xl font-bold mb-3" style={{ color: "#013A51" }}>
                                    Scan Vendor QR Codes
                                </h2>
                                <p className="text-lg mb-4" style={{ color: "#708372" }}>
                                    Point your camera at any vendor's QR code to instantly access their details and special offers.
                                </p>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm" style={{ color: "#8B6F4C" }}>
                                    <div className="flex items-center justify-center gap-2">
                                        <span><AppIcon kind="camera" /></span>
                                        <span>Point & Scan</span>
                                    </div>
                                    <div className="flex items-center justify-center gap-2">
                                        <span><AppIcon kind="bolt" /></span>
                                        <span>Instant Access</span>
                                    </div>
                                    <div className="flex items-center justify-center gap-2">
                                        <span><AppIcon kind="bullseye" /></span>
                                        <span>Vendor Details</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        {/* Scanner Card */}
                        <div className="bg-white bg-opacity-60 backdrop-blur-sm rounded-2xl p-6 shadow-lg" style={{ borderLeft: `4px solid #7999BA` }}>
                            {isScanning ? (
                                <div className="space-y-6">
                                    <div className="text-center">
                                        <h3 className="text-xl font-bold mb-2" style={{ color: "#013A51" }}>
                                            Camera Scanner
                                        </h3>
                                        <p className="text-sm" style={{ color: "#708372" }}>
                                            Position the QR code within the camera frame
                                        </p>
                                    </div>

                                    {/* Scanner Container */}
                                    <div className="flex justify-center">
                                        <div className="relative bg-white rounded-2xl p-4 shadow-lg max-w-sm w-full">
                                            <div className="aspect-square rounded-xl overflow-hidden bg-black">
                                                <QR 
                                                    onScan={handleScan} 
                                                    constraints={{ facingMode: 'environment' }} 
                                                    components={{ finder: false, torch: true }}
                                                    styles={{
                                                        container: { width: '100%', height: '100%' },
                                                        video: { borderRadius: '12px' }
                                                    }}
                                                />
                                            </div>
                                            
                                            {/* Scanner Overlay */}
                                            <div className="absolute inset-4 rounded-xl border-2 border-dashed border-white opacity-50 pointer-events-none"></div>
                                            
                                            {/* Corner Indicators */}
                                            <div className="absolute top-6 left-6 w-6 h-6 border-l-4 border-t-4 rounded-tl-lg" style={{ borderColor: "#DB1C7D" }}></div>
                                            <div className="absolute top-6 right-6 w-6 h-6 border-r-4 border-t-4 rounded-tr-lg" style={{ borderColor: "#DB1C7D" }}></div>
                                            <div className="absolute bottom-6 left-6 w-6 h-6 border-l-4 border-b-4 rounded-bl-lg" style={{ borderColor: "#DB1C7D" }}></div>
                                            <div className="absolute bottom-6 right-6 w-6 h-6 border-r-4 border-b-4 rounded-br-lg" style={{ borderColor: "#DB1C7D" }}></div>
                                        </div>
                                    </div>

                                    {/* Scanner Status */}
                                    <div className="text-center">
                                        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full" style={{ backgroundColor: "rgba(112, 131, 114, 0.2)" }}>
                                            <div className="w-2 h-2 rounded-full animate-pulse" style={{ backgroundColor: "#708372" }}></div>
                                            <span className="text-sm font-medium" style={{ color: "#708372" }}>
                                                Ready to scan
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                // Success State
                                <div className="text-center space-y-6">
                                    <div className="mb-4">
                                        <div className="w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: "rgba(112, 131, 114, 0.2)" }}>
                                            <span className="text-3xl"><AppIcon kind="check" /></span>
                                        </div>
                                        <h3 className="text-2xl font-bold mb-2" style={{ color: "#013A51" }}>
                                            QR Code Scanned Successfully!
                                        </h3>
                                        <p className="text-lg" style={{ color: "#708372" }}>
                                            Redirecting you to vendor details...
                                        </p>
                                    </div>

                                    <div className="bg-white bg-opacity-80 rounded-xl p-4" style={{ borderLeft: `3px solid #DB1C7D` }}>
                                        <p className="text-sm font-medium" style={{ color: "#8B6F4C" }}>
                                            Scanned: {lastScan}
                                        </p>
                                    </div>

                                    <button
                                        onClick={resetScanner}
                                        className="px-6 py-3 rounded-xl font-semibold transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg backdrop-blur-sm text-white"
                                        style={{ backgroundColor: "rgba(219, 28, 125, 0.9)" }}
                                    >
                                        Scan Another Code
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* Tips Card */}
                        <div className="mt-8 bg-white bg-opacity-60 backdrop-blur-sm rounded-2xl p-6 shadow-lg" style={{ borderLeft: `4px solid #DDB649` }}>
                            <h3 className="text-xl font-bold mb-4" style={{ color: "#013A51" }}>
                                <AppIcon kind="note" /> Scanning Tips
                            </h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div className="flex items-start gap-3">
                                    <span className="text-lg"><AppIcon kind="lightbulb" /></span>
                                    <div>
                                        <p className="font-semibold text-sm mb-1" style={{ color: "#013A51" }}>Good Lighting</p>
                                        <p className="text-xs" style={{ color: "#8B6F4C" }}>Ensure adequate lighting for best results</p>
                                    </div>
                                </div>
                                <div className="flex items-start gap-3">
                                    <span className="text-lg"><AppIcon kind="ruler" /></span>
                                    <div>
                                        <p className="font-semibold text-sm mb-1" style={{ color: "#013A51" }}>Proper Distance</p>
                                        <p className="text-xs" style={{ color: "#8B6F4C" }}>Hold 6-12 inches away from QR code</p>
                                    </div>
                                </div>
                                <div className="flex items-start gap-3">
                                    <span className="text-lg"><AppIcon kind="bullseye" /></span>
                                    <div>
                                        <p className="font-semibold text-sm mb-1" style={{ color: "#013A51" }}>Center Frame</p>
                                        <p className="text-xs" style={{ color: "#8B6F4C" }}>Keep QR code centered in camera view</p>
                                    </div>
                                </div>
                                <div className="flex items-start gap-3">
                                    <span className="text-lg"><AppIcon kind="bolt" /></span>
                                    <div>
                                        <p className="font-semibold text-sm mb-1" style={{ color: "#013A51" }}>Stay Steady</p>
                                        <p className="text-xs" style={{ color: "#8B6F4C" }}>Hold device steady for quick scanning</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Scanner;
